import type { ReactNode } from "react";
import { AppSidebar } from "@/components/layout/AppSidebar";
import { InsightPanel } from "@/components/layout/InsightPanel";
import { mockInsightPanelSnapshot } from "@/lib/mock-data";
import type { FinOpsInsightPanel } from "@/types";

type AppShellProps = {
  children: ReactNode;
  /** When omitted, uses default mock insights (e.g. landing page). */
  insights?: FinOpsInsightPanel;
  /** Optional custom side panel to replace the default InsightPanel. */
  sidePanel?: ReactNode;
};

export function AppShell({ children, insights, sidePanel }: AppShellProps) {
  const panelData = insights ?? mockInsightPanelSnapshot;

  return (
    <div className="flex h-dvh max-h-dvh w-full min-w-0 overflow-x-auto bg-background text-foreground">
      <AppSidebar />
      <div className="flex min-h-0 min-w-0 flex-1 flex-col bg-(--bg-center)">
        {children}
      </div>
      {sidePanel ?? <InsightPanel data={panelData} />}
    </div>
  );
}
